$(document).ready(function () {
  $(".multiple-items").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    prevArrow:
      "<img class='a-left control-c prev slick-prev' style='object-fit:contain;' src='https://cdn.shopify.com/s/files/1/0524/5717/7238/files/arrow-left.png?v=1630338749'>",
    nextArrow:
      "<img class='a-right control-c next slick-next' style='object-fit:contain;' src='https://cdn.shopify.com/s/files/1/0524/5717/7238/files/arrow-right.png?v=1630338749'>",
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }); 
});
